import type { Components } from '@mui/material/styles';

export default function MUIBottomNavigation(): Components['MuiBottomNavigation'] {
  return {};
}
